import { PatientKind } from "common/types";

import {
  FilterDefinition,
  FilterValue,
  ProductLineSearchFilters,
  SelectedCategoryProductLineFilters,
  SelectedProductFilters,
  defineFilter,
} from "../types";

/** Filters offered on product results: search and deals. */
export const PRODUCT_FILTER_DEFINITIONS: FilterDefinition<SelectedProductFilters>[] = [
  defineFilter({
    key: "species",
    label: "Species",
    optionsFrom: (options) => options.species,
    selectedFrom: (filters) => filters.species,
    toUpdate: (species) => ({ species }),
  }),
  defineFilter({
    key: "category",
    label: "Categories",
    optionsFrom: (options) => options.categories,
    selectedFrom: (filters) => filters.category_ids,
    toUpdate: (category_ids) => ({ category_ids }),
  }),
  defineFilter({
    key: "manufacturer",
    label: "Manufacturers",
    optionsFrom: (options) => options.manufacturers,
    selectedFrom: (filters) => filters.manufacturer_ids,
    toUpdate: (manufacturer_ids) => ({ manufacturer_ids }),
  }),
  defineFilter({
    key: "prescription_required",
    label: "Type",
    optionsFrom: (options) => options.prescription_required,
    selectedFrom: (filters) => filters.prescription_required,
    toUpdate: (prescription_required) => ({ prescription_required }),
  }),
];

/**
 * Filters offered on the category page, which searches product lines. Category is absent because
 * the page is already scoped to one.
 */
export const CATEGORY_PRODUCT_LINE_FILTER_DEFINITIONS: FilterDefinition<
  SelectedCategoryProductLineFilters,
  FilterValue,
  ProductLineSearchFilters
>[] = [
  defineFilter<SelectedCategoryProductLineFilters, PatientKind, ProductLineSearchFilters>({
    key: "species",
    label: "Species",
    optionsFrom: (options) => options.species,
    selectedFrom: (filters) => filters.species,
    toUpdate: (species) => ({ species }),
  }),
  defineFilter<SelectedCategoryProductLineFilters, number, ProductLineSearchFilters>({
    key: "manufacturer",
    label: "Manufacturers",
    optionsFrom: (options) => options.manufacturers,
    selectedFrom: (filters) => filters.manufacturer_ids,
    toUpdate: (manufacturer_ids) => ({ manufacturer_ids }),
  }),
  defineFilter<SelectedCategoryProductLineFilters, boolean, ProductLineSearchFilters>({
    key: "prescription_required",
    label: "Type",
    optionsFrom: (options) => options.prescription_required,
    selectedFrom: (filters) => filters.prescription_required,
    toUpdate: (prescription_required) => ({ prescription_required }),
  }),
];
